module.exports = __webpack_public_path__ + "img/e_3_21_r.9188f8f7.png";